<template>
  <div
    class="item-base"
    @click="onItemClick"
    :data-menu-id="itemDataMod.id"
    :data-logic-menu-id="itemDataMod.logicMenuId"
    :class="{
      category: isCategory,
      movie: itemDataMod.itemType === 2,
      hasCounselor: isCounselor,
      tarotMenu: isTarotMenu,
    }">
    <div class="itembody">
      <div class="thumbnail" v-if="hasCatThumb" :class="{ counselor: isCounselor}">
        <img :src="thumbUrl" v-if="thumbUrl">
        <span v-else class="nophoto">NO IMAGE</span>
        <span v-if="videoDuration" class="videoDuration">{{videoDuration | secondsToMinutesAndSeconds}}</span>
      </div>
      <item-heading
        class="item-heading"
        :title="itemDataMod.name"
        :is-small="!!itemDataMod.isSmall"
        :show-seelater="isCategory"
        :is-category="isCategory"
        :user-id="!!userProfile ? +userProfile.id : null"
        :item-data="itemDataMod"
      />
      <template v-if="hasTags">
        <div class="menu-tags" v-if="tags.length > 0">
          <span class="tag-icon"><img src="/static/img/icons/ic_tag.svg"></span>
          <tag-list :tag-list="tags" :link-enable="textMenuOpenTrigger && !forceDisableTagLink" />
        </div>
      </template>

      <div class="description" :class="{ hasCounselorData: hasCounselorData, shotage: isShortage, close: !textMenuOpenTrigger}">
        <span class="counselor-img" v-if="hasCounselorData" :class="{nophoto: isCThumbError}">
          <img :src="counselorImg" :alt="counselorName" @load="onCThumbLoad" @error="onCThumbError" />
        </span>
        <span class="excerpt-body" v-html="excerpt" v-if="!textMenuOpenTrigger"></span>
        <span class="description-body" v-html="description" v-else ></span>
      </div>
    </div>


    <div class="has-partner-info" v-if="hasPartner && textMenuOpenTrigger" @click.stop="onChangePartnerClick">相手を変更して占う</div>

    <div class="itemfoot" v-if="!isPreview">
      <fav-button
        @fav-click="onFavClick"
        :fav-status="favStatus"
        :fav-num="favNum"
        v-if="!isCategory"
        :class="{nofav: noFav}"
      />
      <span class="close-datetime" v-if="itemDataMod.closeDatetime">{{itemDataMod.closeDatetime | closeDateTimeStr}}</span>
      <link-icon
        :icon-type="linkIconType"
        :is-opened="textMenuOpenTrigger"
        :is-playlist-text-menu="isPlaylistTextMenu"
      />
    </div>

    <transition>
      <div class="loader" v-if="!loadComplete"></div>
    </transition>
  </div>
</template>

<script>
import TagList from "@/utvStore/components/partials/TagList";
import ItemHeading from "@/utvStore/components/partials/ItemHeading";
import LinkIcon from "@/utvStore/components/partials/LinkIcon";
import FavButton from '@/utvStore/components/partials/FavButton'
import { MENU_SEC_TYPES, SEC_ICON_TYPE, MENU_ITEM_TYPE } from '@/CONSTS/MENUS'
import {mapState} from 'vuex'
import * as type from "@/utvStore/store/mutation-types";
export default {
  name: "PlaylistItem",
  components: {LinkIcon, ItemHeading, TagList, FavButton},
  data(){
    return {
      loadComplete: false,
      // isCounselor: false,
      isShortage: false,
      isCThumbError: false,
      itemDataMod: {},
      favNum: 0,
      favStatus: false,
      textMenuOpenTrigger: false
    }
  },
  props: {
    noFav: {
      type: Boolean,
      default: false,
    },
    forceDisableTagLink: {
      type: Boolean,
      default: false,
    },
    detailForceOpenTrigger: {
      type: Boolean,
      default: false,
    },
    allLock: {
      type: Boolean,
      default: false,
    },
    itemData: {
      type: Object,
      default() {
        return {}
      }
    },
    isCategory: {
      type: Boolean,
      default: false,
    },
    categoryId: {
      type: Number,
      return: 0
    },
    userProfile: {
      type: Object,
      default() {
        return {}
      }
    },
    isSeelaterHistory: {
      type: Boolean,
      default: false,
    },
    scrollClass: {
      type: String,
      default: '.list-body'
    },
    scrollTgtIsWindow: {
      type: Boolean,
      default: false,
    },
    isPreview: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    itemData: {
      handler(val){
        this.setItemData()
      },
      deep: true
    },
    detailForceOpenTrigger(val){
      this.textMenuOpenTrigger = val
    },
    subscriptVideoData: {
      handler(){
        // console.log(' subscriptVideoData:%O', this.subscriptVideoData)
      },
      deep: true
    },
    openedTextDetailID(val) {
      if (val > 0){
        this.textMenuOpenTrigger = val === +this.itemDataMod.id
        if(val === +this.itemDataMod.id) {
          const listbase = document.querySelector(this.scrollClass)
          this.textMenuOpenTrigger = true
          if(!!listbase) {
            if(this.scrollTgtIsWindow){
              const head = document.querySelector('header.header')
              window.scrollTo({top: window.scrollY + this.$el.getBoundingClientRect().top - head.clientHeight})
            }else{
              listbase.scrollTo({top: listbase.scrollTop + (this.$el.getBoundingClientRect().top - listbase.getBoundingClientRect().top)})
            }
          }
        }else{
          this.textMenuOpenTrigger = false
        }
      }else {
        this.textMenuOpenTrigger = false
      }
    }
  },
  computed: {
    ...mapState({
      accessToken: states => states.auth.accessToken,
      subscriptVideoData: states => states.item.subscrItems,
      openedTextDetailID: states => states.item.openedTextDetailID
    }),
    hasCatThumb() {
      if(this.isSeelaterHistory) return !!this.itemDataMod.counselor && !!this.itemDataMod.counselor.id
      return (this.isCategory && this.categoryId === 3) || this.itemDataMod.itemType === MENU_ITEM_TYPE.movie
    },
    isCounselor() {
      return !!this.itemDataMod.counselor && !!this.itemDataMod.counselor.id
    },
    thumbUrl(){
      let thumb = ''
      if(this.itemDataMod.itemType === MENU_ITEM_TYPE.movie){
        //動画の場合
        thumb = !!this.itemDataMod.videoData ? this.itemDataMod.videoData.thumbnail : ''
      } else {
        if (!!this.itemDataMod.counselor && !!this.itemDataMod.counselor.image_url) {
          thumb = this.itemDataMod.counselor.image_url
        }
      }
      return thumb
    },
    videoDuration(){
      return !!this.itemDataMod.videoData ? this.itemDataMod.videoData.duration : 0
    },
    hasCounselorData() {
      return !!this.itemDataMod.counselor && this.itemDataMod.itemType === MENU_ITEM_TYPE.text && !this.isPreview
    },
    counselorImg() {
      if(!!this.itemDataMod.counselor && !!this.itemDataMod.counselor.thumbnail){
        return this.itemDataMod.counselor.thumbnail
      }else{
        return ''
      }
    },
    counselorName() {
      if(!!this.itemDataMod.counselor && !!this.itemDataMod.counselor.name){
        return this.itemDataMod.counselor.name
      }else{
        return ''
      }
    },
    linkIconType() {
      if(this.isCategory) return SEC_ICON_TYPE.none
      return this.itemDataMod.itemType === MENU_ITEM_TYPE.movie ? SEC_ICON_TYPE.movie : SEC_ICON_TYPE.text
    },
    hasTags(){
      return this.itemDataMod ? !!this.itemDataMod.tags : false
    },
    excerpt() {
      const lfstr = '__linefeed__'
      let desc = !!this.itemDataMod.result ? !!this.itemDataMod.result.text ? this.itemDataMod.result.text : '' : ''
      // desc = desc.replace(/<br>/g, lfstr ) //<br>を退避
      desc = desc.replace(/<("[^"]*"|'[^']*'|[^'">])*>/g,'') //htmlタグ削除
      // desc = desc.replace(new RegExp(lfstr,'g'), '<br>') //<br>を復号

      const userShortageList = []
      const targetShortageList = []

      if(!!this.itemDataMod.info && this.itemDataMod.info.length > 0){
        // for(let key in this.itemDataMod.info[0]) {
        for(let item of this.itemDataMod.info) {
          for(let key in item){
            const word = key.replace(/[A-Z]/g, s => "_" + s.charAt(0).toLowerCase())
            if(/^target_/.test(word)){
              targetShortageList.push(item[key])
            } else {
              userShortageList.push(item[key])
            }
          }
        }
        desc = ''
        this.isShortage = false
        if(userShortageList.length > 0){
          desc += `<span class="shortage-mess">自分:${userShortageList.join('、')}</span>`
          this.isShortage = true
        }
        if(targetShortageList.length > 0){
          desc += `<span class="shortage-mess">相手:${targetShortageList.join('、')}</span>`
          this.isShortage = true
        }
      }else{
        if(this.itemDataMod ? this.itemData.isTarotMenu : false){
          desc = ''
        }
      }
      return desc
    },
    description() {
      return !!this.itemDataMod.result ? !!this.itemDataMod.result.text ? this.itemDataMod.result.text : '' : ''
    },
    hasDescription() {
      let res = !this.isTarotMenu
      return res
    },
    isTarotMenu(){
      return this.itemDataMod ? this.itemData.isTarotMenu : false
    },
    tags() {
      const rtn = []
      if(!!this.itemDataMod && !!this.itemDataMod.tags ){
        this.itemDataMod.tags.forEach(val=>{
          if(!/^_/.test(val.tagName)){
            rtn.push({ ...val, label: val.tagName })
          }
        })
      }
      return rtn
    },
    isPlaylistTextMenu(){
      return !this.isCategory && this.itemDataMod.itemType === MENU_ITEM_TYPE.text
    },
    hasPartner(){
      return this.isRequirePartner
    },
    isRequirePartner(){
      if(!!this.itemDataMod.required && this.itemDataMod.required.length > 0){
        return this.itemDataMod.required.some(item =>{
          return Object.keys(item)[0].includes('target')
        })
      }else{
        return false
      }
    }
  },
  created() {
    this.setItemData()
  },
  mounted() {
    this.loadComplete = true
    // console.log('テキストアイテムか？[%s(%s)] itemType: %s data: %O', this.itemDataMod.name, this.itemDataMod.itemType === MENU_ITEM_TYPE.text, this.itemDataMod.id, this.itemDataMod.itemType, this.itemDataMod)
  },

  methods: {
    setItemData (){
      this.favNum = this.itemData.localFavNum
      this.favStatus = this.itemData.localFavStat
      this.itemDataMod = this.itemData
    },
    onFavClick() {
      //ここで自身のfavStatusとfavNumを設定
      if(!!this.userProfile) {
        this.$store.dispatch(type.SET_ITEM_FAVORITE, {
          menuId: this.itemData.id,
          stat: !this.favStatus,
          userId: this.userProfile.id,
          accToken: this.accessToken
        })
      }
    },
    onItemClick() {
      // console.log('onItemClick: 対象のmenuIdは:%s', this.itemData.id)
      if(this.loadComplete && this.allLock === false){
        if(this.isPlaylistTextMenu && this.textMenuOpenTrigger && !this.itemDataMod.nonPlaylistItem){
          // this.textMenuOpenTrigger = false
          this.$store.dispatch(type.SET_TEXT_DETAIL_OPEN)
        }else{
          this.$emit('open-item', {id: this.itemData.id, elm: this.$el})
        }
      }
    },
    onChangePartnerClick() {
      this.$emit('change-partner-click', this.itemDataMod.id)
    },
    onCThumbError(e){
      this.isCThumbError = true
    },
    onCThumbLoad(e){},
  },
  filters: {
    closeDateTimeStr(dt){
      return `配信終了予定：${dt.format('YYYY/MM/DD')}まで`
    }
  }
}
</script>

<style scoped lang="scss">
@import "../../../../sass/commons/commonVariables.scss";

.item-base {
  width: 100%;
  min-height: 80px;
  padding: 25px 20px;
  border-bottom: 1px solid $col_temp_gray3;
  position: relative;
  color: $col_dark_font;
  .itembody {
    .thumbnail {
      $largeSize: 85px;
      width: $largeSize;
      height: $largeSize;
      border-radius: $largeSize / 2;
      margin-right: 16px;
      overflow: hidden;
      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        display: block;
      }
    }
  }
  .has-partner-info{
    font-size: 13px;
    font-weight: bold;
    text-align: right;
    padding-right: 12px;
    margin: 16px 0 12px;
    text-decoration: underline;
    color: $col_temp_gray6;
    width: 100%;
  }
  .itemfoot {
    text-align: right;
    line-height: 1;
    padding: 15px 0 0;
    margin-right: -6px;
    display: flex;
    justify-content: space-between;
    /deep/ .fav-btn-base {
      margin-top: 2px;
      &.nofav {
        visibility: hidden;
      }
      & > span {
        display: inline-block;
        line-height: 0.7;
      }
      svg {
        width: 17px;
      }
      .fav-num {
        font-size: 11px;
        margin-left: 4px;
      }
    }
  }

  &.category {
    height: 88px;
    padding: 20px 20px 25px;
    &.hasCounselor {
      height: auto;
      padding: 25px 20px;
    }

    .itembody {
      display: flex;
      min-height: 48px;
      .item-heading {
        flex: 1;
      }
    }
    .itemfoot {
      position: absolute;
      bottom: 20px;
      right: 20px;
    }
    /deep/ .seelater {
      margin-top: 0;
      line-height: 1;
    }
  }

  &.movie {
    .itembody {
      height: 90px;
      display: block;
      padding-left: calc(160px + 16px);
      position: relative;
      /deep/ h3 {
        font-size: 14px;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        /* autoprefixer: ignore next */
        -webkit-box-orient: vertical;
        overflow: hidden;
      }
      .thumbnail {
        width: 160px;
        height: 90px;
        border-radius: 0;
        position: absolute;
        top: 0;
        left: 0;

        .videoDuration{
          position: absolute;
          background: $col_temp_black;
          color: $col_white;
          bottom: 6px;
          right: 9px;
          border-radius: 2px;
          padding: 0 4px;
          font-size: 11px;
          letter-spacing: 0.5px;
        }
      }

      .menu-tags {
        /deep/ .tag-list-base {
          display: inline-block;
          color: $col_normal_font;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          /* autoprefixer: ignore next */
          -webkit-box-orient: vertical;
          overflow: hidden;
          /*
          line-height: 1;
          padding-top: 3px;
          & > li {
            font-size: 11px;
            line-height: 16px;
            margin-right: 4px;
          }
          */
        }
      }
    }
  }
  &.tarotMenu {
    .description {
      .counselor-img {
        float: none;
      }
    }
  }
}



.nophoto {
  line-height: 1;
  font-size: 11px;
  color: $col_temp_key1;
  background: $col_lite_gradient;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}


.loader {
  width: 100%;
  height: 100%;
  background: url('/static/img/common/loading.svg') no-repeat center center rgba(255,255,255,0.9);
  background-size: 12vw 12vw;
  position: absolute;
  top: 0;
  left: 0;
}
.menu-tags {
  display: block;
  padding-left: 18px;
  position: relative;
  margin-bottom: 14px;
  .tag-icon {
    display: inline-block;
    position: absolute;
    top: 3px;
    left: 0;
    width: 13px;
    img {
      display: block;
      width: 100%;
    }
  }
  /deep/ .tag-list-base {
    color: $col_normal_font;
  }
  ///deep/ .tag-list-base {
  //  display: inline-block;
  //  line-height: 1;
  //  color: $col_normal_font;
  //  display: -webkit-box;
  //  -webkit-line-clamp: 2;
  //  /* autoprefixer: ignore next */
  //  -webkit-box-orient: vertical;
  //  overflow: hidden;
  //  padding-top: 3px;
  //  & > li {
  //    font-size: 11px;
  //    line-height: 16px;
  //    margin-right: 4px;
  //  }
  //}
}
.description {
  font-weight: normal;
  font-size: 13px;
  line-height: 21px;
  color: $col_normal_font;
  overflow: hidden;
  position: relative;
  .counselor-img {
    display: none;
  }
  .excerpt-body {
  }
  &.shotage {
    .excerpt-body {
      float: left;
    }
  }
  &.close {
    .excerpt-body {
      display: -webkit-box;
      -webkit-line-clamp: 3;
      /* autoprefixer: ignore next */
      -webkit-box-orient: vertical;
    }
  }
  &.hasCounselorData {
    //padding-left: calc(55px + 12px);
    min-height: 60px;
    .counselor-img {
      width: 55px;
      height: 55px;
      display: block;
      overflow: hidden;
      border-radius: 30px;
      float: left;
      margin-right: 12px;
      //position: absolute;
      //top: 4px;
      //left: 0;
      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
      &.nophoto {
        img{
          display: none;
        }
        &::after {
          content: 'NO IMAGE';
          width: 100%;
          height: 100%;
          line-height: 1;
          transform: scale(0.8);
          font-size: 10px;
          color: $col_temp_key1;
          background: $col_lite_gradient;
          display: flex;
          justify-content: center;
          align-items: center;
        }
      }
    }
  }
}

/deep/ .shortage-mess {
  display: block;
  width: 100%;
  background: url('/static/img/icons/ic_warning.svg') no-repeat left 4px;
  background-size: 15px 12px;
  font-weight: normal;
  font-size: 13px;
  line-height: 21px;
  padding-left: 20px;
}

.close-datetime{
  display: inline-block;
  font-size: 14px;
  font-weight: bold;
  line-height: 1;
  color: $col_temp_key1;
  background: #fff5f8;
  border-radius: 7px;
  padding: 6px 12px;
}
.v-enter-active,
.v-leave-active {
  transition: all 200ms ease-out 0s;
}

.v-enter, .v-leave-to {
  opacity: 0;
}

.v-enter-to, .v-leave {
  opacity: 1;
}
</style>

<style lang="scss">
.item-base .tag-list-base li {
  font-size: 11px;
}
</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/Playlist/PlaylistItem.vue